<template>
  <tr :class="{ disabled: entity.timestamp_deleted, clickable: $_loggedUser_action_allowed('users', 'read')}" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <td :data-th="'Přihlašovací jméno'" class="first_data"><strong>{{ entity.login }}</strong></td>
    <td :data-th="'Jméno'">{{ entity.name }}</td>
    <td :data-th="'Operátor'">{{ entity.operator }}</td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions";

export default {
  name: "UsersRow",
  mixins: [rowActions],
  props: {
    entity: Object,
    enabled: Boolean,
  },
  methods: {
    goToDetail(e, id) {
      if(this.$_loggedUser_action_allowed('users', 'read')) {
        this.$router.push({name: 'userDetail', params: {id: id}});
      }
    },
  },
};

</script>



// WEBPACK FOOTER //
// src/components/views/roleGroups/detail/UsersRow.vue